import React from 'react';
import * as moment from 'moment';

export default class Footer extends React.Component {
  render() {
    return (
      <footer>
        © Copyright {moment().year()} <span className="text-red">SCHelper</span>- All Rights Reserved.
      </footer>
    )
  } 
}
